export const foreignKeyMapping = {
  contacts: "contact_id",
  deals: "deal_id",
};
